import axios from 'axios';
import API_CONFIG from '../config/api.config';
import { getAuthHeader } from './authService';

const BASE_URL = `${API_CONFIG.BASE_URL}/companies`;

export const companySettingsService = {
  // Get current company settings
  getSettings: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/settings`, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching company settings:', error);
      throw error;
    }
  },

  // Update company settings
  updateSettings: async (settings) => {
    try {
      const response = await axios.put(`${BASE_URL}/settings`, settings, {
        headers: getAuthHeader()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating company settings:', error);
      throw error;
    }
  },

  // Upload company logo
  uploadLogo: async (file) => {
    try {
      const formData = new FormData();
      formData.append('logo', file);
      
      const response = await axios.post(`${BASE_URL}/settings/logo`, formData, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading logo:', error);
      throw error;
    }
  },

  // Upload footer image (QR code for shop location, reviews)
  uploadFooterImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('footerImage', file);
      
      const response = await axios.post(`${BASE_URL}/settings/footer-image`, formData, {
        headers: {
          ...getAuthHeader(),
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading footer image:', error);
      throw error;
    }
  },

  // Page field visibility (e.g. POS Sales Keyboard: show/hide UOM, Discount, Tax, SKU)
  getPageFieldConfig: async (pageKey) => {
    try {
      const response = await axios.get(`${BASE_URL}/settings/page-fields`, {
        params: { pageKey },
        headers: getAuthHeader()
      });
      return response.data?.fieldConfig ?? {};
    } catch (error) {
      console.error('Error fetching page field config:', error);
      throw error;
    }
  },

  updatePageFieldConfig: async (pageKey, fieldConfig) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/settings/page-fields`,
        { pageKey, fieldConfig },
        { headers: getAuthHeader() }
      );
      return response.data?.fieldConfig ?? {};
    } catch (error) {
      console.error('Error updating page field config:', error);
      throw error;
    }
  }
};

export default companySettingsService; 